import React, { useRef } from 'react';
import * as PropTypes from 'prop-types';

import S from './modal-business-group.module.scss';
import { ModalBusinessGroupForm } from './modal-business-group-form';
import { CloseButton } from '../../common/buttons/close-button';
import { useOverlayClick } from '../../../helpers/hooks/use-overlay-click';

const ModalBusinessGroup = ({ onClose, onSuccess, id }) => {
  const MODAL_REF = useRef();

  useOverlayClick(MODAL_REF, onClose);

  return (
    <div ref={MODAL_REF} className={S.businessGroupModal}>
      <CloseButton onClick={onClose} />
      <ModalBusinessGroupForm
        handleClose={onClose}
        handleOnSuccess={onSuccess}
        id={id}
      />
    </div>
  );
};

ModalBusinessGroup.displayName = 'ModalBusinessGroup';

ModalBusinessGroup.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  id: PropTypes.string
};

export { ModalBusinessGroup };
